import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "format-bold",
  "use": "format-bold-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"format-bold\"><path fill-rule=\"evenodd\" d=\"M16.875 9c0-2.26-1.75-4-4-4h-6.25v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42.97-.67 1.65-1.77 1.65-2.79Zm-4.25-1.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3h3Zm-3 9v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol